import { FeatureFlag } from "store/api/generatedApi";

export const PROJECTIONS_FEATURE_FLAG: FeatureFlag =
  "strategy_dashboard_consumption_projection";
